import React, {Component} from "react";
import { Link } from "react-router-dom";
import rka from "./image/anggaran.png";
import aset from "./image/asset.jpg";
import realisasi from "./image/realisasi.png";
import "./Dashboard.css";

function Dasboard() {
    return(
        <>
        <div className="container-fluid">
            <div className="row g-0">
                <div className="col-md-4 p-5 row g-0">
                    <div className="col-md-12 row g-0 rounded border border-2 border-secondary-subtle shadow-lg p-3" >
                        <div className="col-md-12 text-center fw-bolder fs-5 border-bottom border-3 border-primary-subtle fc-1">
                            Rencana Kerja dan Anggaran Universitas
                        </div>
                        <div className="col-md-4 text-center">
                            <img src={rka} className="img-fluid" height="150" width="150" style={{objectFit: "cover"}}></img>
                        </div>
                        <div className="col-md-8 p-2 row g-0">
                            <div className="col-md-12">
                                <p className="border-bottom">RKA Tahun 2025</p>
                            </div>
                            <div className="col-md-6">Perencanaan</div>
                            <div className="col-md-6">Rp. 181818181</div>
                            <div className="col-md-6">Realisasi</div>
                            <div className="col-md-6">Rp. 181818181</div>
                            <div className="col-md-6">-</div>
                            <div className="col-md-6">-</div>
                            <Link to='/rka' className="col-md-12 setup-rka text-center text-light rounded p-3">
                                Lihat Selengkapnya
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="col-md-4 p-5 row g-0">
                    <div className="col-md-12 row g-0 rounded border border-2 border-secondary-subtle shadow-lg p-3" >
                        <div className="col-md-12 text-center fw-bolder fs-5 border-bottom border-3 border-warning-subtle fc-2">
                            Pembiayaan Kegiatan Universitas
                        </div>
                        <div className="col-md-4 text-center">
                            <img src={realisasi} className="img-fluid" height="150" width="150" style={{objectFit: "cover"}}></img>
                        </div>        
                        <div className="col-md-8 p-2 row g-0">
                            <div className="col-md-12">
                                <p className="border-bottom">Pembiayaan Kegiatan Tahun 2025</p>
                            </div>
                            <div className="col-md-6">Realisasi</div>
                            <div className="col-md-6">Rp. 181818181</div>
                            <div className="col-md-6">-</div>
                            <div className="col-md-6">-</div>
                            <div className="col-md-6">-</div>
                            <div className="col-md-6">-</div>
                            <Link to='/usulan-pembiayaan' className="col-md-12 setup-up text-center text-light rounded p-3">
                                Lihat Selengkapnya
                            </Link>
                        </div>
                    </div>
                </div>
                
                <div className="col-md-4 p-5 row g-0">
                    <div className="col-md-12 row g-0 rounded border border-2 border-secondary-subtle shadow-lg p-3" >
                        <div className="col-md-12 text-center fw-bolder fs-5 border-bottom border-3 border-success-subtle fc-3">
                            Inventaris Aset Universitas
                        </div>
                        <div className="col-md-4 text-center">
                            <img src={aset} className="img-fluid" height="150" width="150" style={{objectFit: "cover"}}></img>
                        </div>
                        <div className="col-md-8 p-2 row g-0">
                            <div className="col-md-12">
                                <p className="border-bottom">Rekapitulasi Aset Universitas</p>
                            </div>
                            <div className="col-md-6">Penambahan 2025</div>
                            <div className="col-md-6">Rp. 181818181</div>
                            <div className="col-md-6">Total Pengurangan</div>
                            <div className="col-md-6">Rp.</div>
                            <div className="col-md-6">Total Aset</div>
                            <div className="col-md-6">Rp. </div>
                            <Link to='/inventaris' className="col-md-12 setup-as text-center text-light rounded p-3">
                                Lihat Selengkapnya
                            </Link>
                        </div>
                    </div>
                </div>

            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
        </div>
        </>
    )
}
export default Dasboard;